import { Box, SvgIcon, Typography } from '@mui/material'
import { FC } from 'react'
import { icons } from '../../../../../../assets'
import useStyles from './styles'
import { SharedEstimateIndicatorProps } from './types'


const SharedEstimateIndicator: FC<SharedEstimateIndicatorProps> = ({ sharedByEmail, sharedByName }) => {
  const styles = useStyles()
  return (
    <Box className={styles.container}>
      <Box className={styles.indicator}>
        <SvgIcon component={icons.AssignmentInd} className={styles.icon} />
        <Typography className={styles.name}>{sharedByName}</Typography>
        <Typography className={styles.text}>{`(${sharedByEmail}) shared this Estimate`}</Typography>
      </Box>
    </Box>
  )
}

export default SharedEstimateIndicator;

